// extracted by mini-css-extract-plugin
export default {"invitationResults":"eKcsHMCzefor57bLC06v","messageRow":"Hu6LFXeSb_Qed0VrObnz"};